import React from "react";
import { useLocation } from "react-router-dom";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicNFAtoDFA = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <TOCModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="NFA to DFA Conversion"
      videos={[
        "https://www.youtube.com/embed/6aOtnyL40X8",
      ]}
      takeaways={[
        { text: "Learn the equivalence between NFA and DFA." },
        { text: "Understand the subset construction method for converting NFA to DFA." },
      ]}
      questions={[

      ]}
      exampleVideos={[]} // Add example question videos if needed
    />
  );
}

export { ModuleSubtopicNFAtoDFA };
